import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../lib/axiosInstance';

export const DRS_API = '/stock/drs';

/**
 * Raises a delivery receipt for what a receiving report brought in.
 *
 * Steps 20 to 22: material is collected from the supplier, inspected, then sent
 * on to whoever asked for it. Lines are copied from the receipt so nobody
 * retypes them; the destination is left blank because the receipt does not know
 * who asked.
 */
export const useGenerateDeliveryReceipt = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (rrId: string) => {
      const { data } = await axiosInstance.post(`${DRS_API}/generateDR/${rrId}`);
      return data;
    },
    onSuccess: async () => {
      await queryClient.refetchQueries();
    },
  });
};

/**
 * Moves the receipt through its approval steps.
 *
 * CONFIRM is the preparer sending it on and is treated as an ordinary edit;
 * APPROVED, DONE and CANCEL are decisions and need approve rights, which the
 * API checks against the payload rather than the URL.
 */
export const useUpdateDeliveryReceiptStatus = (drId?: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (body: { status: string; remarks?: string }) => {
      const { data } = await axiosInstance.put(
        `${DRS_API}/${drId}/status`,
        body,
      );
      return data;
    },
    onSuccess: async () => {
      await queryClient.refetchQueries();
    },
  });
};
